
import { Entity } from '../base/entity';
import { Entry } from '../ui/entry';

export class ItemGroup extends Entity implements Entry {

    public static readonly TABLENAME = 'item_group';

    public static readonly ID = "id";
    public static readonly NAME = "name";
    public static readonly PARENT_ID = "parent_id";
    public static readonly COMPANY_ID = "company_id";
    public static readonly CREATED_AT = "created_at";
    public static readonly UPDATED_AT = "updated_at";
    public static readonly DELETED_AT = "deleted_at";
    public static readonly EXCISE = "excise";

    id: number;
    name: string;
    parentId: number;
    companyId: string;
    createdAt: Date;
    updatedAt: Date;
    deletedAt: Date;
    excise: boolean;

    showChild: boolean;

    public key(): any {
        return this.id;
    }

    public value(): any {
        return this.name;
    }

}
